module.exports = __webpack_public_path__ + "media/images/athletes/3424-6bbbccaaf5143e3466a1b3c6862fdaa5.png";